__turbopack_context__.v({
  "badge": "jD5g3q_badge",
  "danger": "jD5g3q_danger",
  "dangerLight": "jD5g3q_dangerLight",
  "dangerVeryLight": "jD5g3q_dangerVeryLight",
  "default": "jD5g3q_default",
  "featured": "jD5g3q_featured",
  "featuredLight": "jD5g3q_featuredLight",
  "featuredVeryLight": "jD5g3q_featuredVeryLight",
  "primary": "jD5g3q_primary",
  "primaryLight": "jD5g3q_primaryLight",
  "primaryVeryLight": "jD5g3q_primaryVeryLight",
  "secondary": "jD5g3q_secondary",
  "secondaryLight": "jD5g3q_secondaryLight",
  "secondaryVeryLight": "jD5g3q_secondaryVeryLight",
  "success": "jD5g3q_success",
  "successLight": "jD5g3q_successLight",
  "successVeryLight": "jD5g3q_successVeryLight",
  "topJob": "jD5g3q_topJob",
  "warning": "jD5g3q_warning",
  "warningLight": "jD5g3q_warningLight",
  "warningVeryLight": "jD5g3q_warningVeryLight",
});
